module.exports.init = require('_core/tls').getUserAgent;